import React from 'react';
import * as Render from '../Base/Render';
import classNames from 'classnames';

const Container = (props) => {
  const { Heading } = props;

  const dataPrintSidebarTitle = Heading || props.CurrentPageProps?.Content?.Translations?.linklistblock || '';
  const listcontainer = "data-list-container"
  return (
    <div
      className={classNames({
        'list-container': true,
        'list-container--has-section-wrapper': props.hasSectionWrapper,
      })}
      data-print-sidebar-title={dataPrintSidebarTitle}
      data-list-container={ listcontainer}
    >
      {Heading && <h2 className="list-container__heading">{Heading}</h2>}
      <Render.Block
        blocks={props.Content}
        propertyName="Content"
        currentPageProps={props.CurrentPageProps}
      >
        <Render.BlockTypeRenderer Blocks={props.Blocks} isH3={Heading} />
      </Render.Block>
    </div>
  );
};

export default Container;
